import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { HiringManagerLabelUI, HiringManagerStatusFilter } from '@shared';
import { difference } from 'lodash';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'mojo-hiring-manager-statuses',
  templateUrl: './hiring-manager-statuses.component.html',
  styleUrls: ['./hiring-manager-statuses.component.scss'],
})
export class HiringManagerStatusesComponent implements OnInit {
  submissionStatus = 'All submission statuses';
  previouslySelected = [this.submissionStatus];
  hmStatuses: string[] = [
    this.submissionStatus,
    HiringManagerLabelUI.SUBMITTED,
    HiringManagerLabelUI.NOT_SUBITTED,
    HiringManagerLabelUI.ADVANCED,
    HiringManagerLabelUI.REJECTED,
  ];

  @Output() selection = new EventEmitter<string[]>();

  form = this.fb.group({
    filter: [[this.submissionStatus], null],
  });
  filter = this.form.get('filter');

  constructor(private fb: UntypedFormBuilder, private route: ActivatedRoute) {
    this.filter.valueChanges.subscribe((selectedStatuses: string[]) => {
      if (selectedStatuses.length > 1 && selectedStatuses.includes(this.submissionStatus)) {
        return;
      } else if (
        selectedStatuses.length === 1 &&
        selectedStatuses.includes(this.submissionStatus)
      ) {
        this.selection.emit([]);
      } else {
        const statuses = this.swithLabels(selectedStatuses);
        this.selection.emit(statuses);
      }
    });
  }

  ngOnInit() {
    const hmStatus = this.route.snapshot.queryParams.hmStatus;

    if (hmStatus && JSON.parse(hmStatus).length > 0) {
      const retrievedHmStatuses = this.returnUILabelHMStatuses();
      this.filter.setValue(retrievedHmStatuses, { emitEvent: false });
      this.previouslySelected = retrievedHmStatuses;
    }
  }

  hmStatusesSelected(e) {
    const selectedStatuses = e.value;
    const diff = difference(selectedStatuses, this.previouslySelected);

    if (selectedStatuses.length === 0) {
      this.filter.setValue([this.submissionStatus]);
    } else if (
      selectedStatuses.length > 0 &&
      selectedStatuses.includes(this.submissionStatus) &&
      !diff.includes(this.submissionStatus)
    ) {
      this.filter.setValue(this.filter.value.filter((val) => val !== this.submissionStatus));
    } else if (
      selectedStatuses.length > 0 &&
      selectedStatuses.includes(this.submissionStatus) &&
      diff.includes(this.submissionStatus)
    ) {
      this.filter.setValue([this.submissionStatus]);
    }
    this.previouslySelected = this.filter.value;
  }

  swithLabels(selectedStatuses: string[]) {
    return selectedStatuses.map((status) => {
      if (status === HiringManagerLabelUI.ADVANCED) {
        return HiringManagerStatusFilter.ADVANCED;
      } else if (status === HiringManagerLabelUI.SUBMITTED) {
        return HiringManagerStatusFilter.SUBMITTED;
      } else if (status === HiringManagerLabelUI.REJECTED) {
        return HiringManagerStatusFilter.REJECTED;
      } else {
        return status;
      }
    });
  }

  returnUILabelHMStatuses() {
    const hmStatusArray = JSON.parse(this.route.snapshot.queryParams.hmStatus);
    if (hmStatusArray.includes('Rejected')) {
      const index = hmStatusArray.indexOf('Rejected');
      hmStatusArray[index] = HiringManagerLabelUI.REJECTED;
    }
    if (hmStatusArray.includes('Advanced')) {
      const index = hmStatusArray.indexOf('Advanced');
      hmStatusArray[index] = HiringManagerLabelUI.ADVANCED;
    }

    return hmStatusArray;
  }
}
